import Vue from 'vue';
import App from './App.vue';

import VueRouter from 'vue-router';
import Home from './components/Home.vue';
import Services from './components/Services.vue';
import BootstrapVue from 'bootstrap-vue';
import Keys from './components/Keys.vue';
import Contacts from './components/Contacts.vue';
import Admin from './components/Admin.vue';
import AdminPage from './components/AdminPage.vue';

import Data from './API';

import { store } from './store';


Vue.use(BootstrapVue)
Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    { path: '', component: Home },
    { path: '/services', component: Services },
    { path: '/keys', component: Keys},
    // { path: '/contacts', component: Contacts },
    { path: '/admin', component: Admin },
    { path: '/admin-page', component: AdminPage }
  ],
  mode: 'history'
})

const userLang = navigator.language || navigator.userLanguage;
userLang.slice(0, 2)

Data.getStart()
  .then(json => {
    console.log(localStorage['lang']);
    if (localStorage['lang'] === 'ru') {
      localStorage.setItem('lang', 'en');
    }
    if (!localStorage.getItem('lang')) {
      if (userLang.slice(0, 2) === 'ua') localStorage.setItem('lang', userLang.slice(0, 2));
      else localStorage.setItem('lang', 'en');
    }
    store.getStart = json.data.data;

    new Vue({
      el: '#app',
      router,
      render: h => h(App),
    })
  })




// WEBPACK FOOTER //
// ./src/main.js